module.exports = __webpack_public_path__ + "img/block_press down_01.0bbcd3b3.png";